import { useState, useCallback } from 'react';
import { Drawer, DrawerBody, Icon } from '@customerio/pluma-components/react';
import { IconButton } from '../icon-button';

export function NotificationsDrawer() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <IconButton label="Notifications" onClick={handleOpen}>
        <Icon name="notifications" size="md" style={{ marginInline: '-2px' }} />
      </IconButton>

      <Drawer isOpen={isOpen} onClose={handleClose} title="Notifications" placement="right" size="sm">
        <DrawerBody />
      </Drawer>
    </>
  );
}
